// extracted by mini-css-extract-plugin
module.exports = {"page_header_title":"styles_page_header_title__3q3m4"};